import { TechRadarApi } from '@backstage-community/plugin-tech-radar';
import { TechRadarLoaderResponse } from '@backstage-community/plugin-tech-radar-common';
import data from './radar-data.json';

export class TechRadarClient implements TechRadarApi {
    async load(_id: string | undefined): Promise<TechRadarLoaderResponse> {
        return {
            ...data,
            entries: data.entries.map(entry => ({
                ...entry,
                key: entry.id,
                timeline: entry.timeline.map(timeline => ({
                    ...timeline,
                    date: new Date(timeline.date),
                })),
            })),
        };
    }
}
